module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiBannerImage-6be3dcfb055679394692b2052afb70f0.png";